export default __webpack_public_path__ + "static/media/icon-SubdirectoryConnect.07c65f9d.svg";